import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types'
import { Modal, ModalBody } from 'reactstrap';
import FormActionButtons from '../../../common/forms/FormActionButtons';
import Validator from '../../../common/forms/Validator';
import Close from '../../../common/ui/Close';
import Select from 'react-select';
import { denyWorkerProspect } from '../../../../actions/prospects';

const options = [
  { label: 'Out of state', value: 'Out of state' },
  { label: 'No show', value: 'No show' },
  { label: 'Failed Background', value: 'Failed Background' },
  { label: 'Failed paper assessment', value: 'Failed paper assessment' },
  { label: 'Insufficient Training', value: 'Insufficient Training' },
  { label: 'Other' , value: 'Other' }
]

class DenyProspectModal extends Validator {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    prospect: PropTypes.object,
    closeModal: PropTypes.func.isRequired
  }

  initialState = {
    reason: '',
    other: false
  }

  state = this.initialState

  denyProspect = ( e ) => {
    e.preventDefault()

    const { reason } = this.state
    const { closeModal, prospect: { id } } = this.props

    this.props.denyWorkerProspect({ reason, id })
      .then(() => this.setState(this.initialState))
      .then(() => closeModal())
  }

  handleChange = ({ value }) => {
    if (value === 'Other') {
      this.setState({ other: true, reason: '' })
    } else {
      this.setState({ other: false, reason: value })
    }
  }

  clearForm = () => {
    this.setState(this.initialState);
  };

  componentDidUpdate (prevProps) {
    if (!this.props.isOpen && prevProps.isOpen) {
      this.clearForm();
    }
  }

  render () {
    const { isOpen, closeModal } = this.props
    const { other, reason } = this.state

    return (
      <Modal isOpen={isOpen}>
        <div className='modal-header'>
          <div className='modal-title'>Deny Candidate</div>
          <Close onClick={closeModal} />
        </div>
        <ModalBody>
          <form onSubmit={this.denyProspect}>
            <div className='form-group'>
              <Select
                value={other ? 'Other' : reason}
                onChange={this.handleChange}
                options={options}
                placeholder={'Choose Reason'}
              />
            </div>
            {other &&
              <div className='form-group'>
                <label htmlFor='reason'>Please Describe</label>
                <input
                  className='input'
                  id='reason'
                  name='reason'
                  type='text'
                  onChange={e => this.setState({ reason: e.target.value })}
                  value={reason}
                />
              </div>
            }
            <FormActionButtons
              onClickCancel={closeModal}
              submitTitle='Deny'
            />
          </form>
        </ModalBody>
      </Modal>
    )
  }
}

export default connect(null, { denyWorkerProspect })(DenyProspectModal);



// WEBPACK FOOTER //
// ./src/components/app/prospectsList/DenyProspectModal/index.js